<template>
  <dl
    v-if="location?.locationName || location?.cityState"
    class="shipping-point-search-result m-0"
  >
    <div v-if="location.locationName">
      <dt class="visually-hidden">{{ t('common.name') }}</dt>
      <dd class="m-0">{{ location.locationName }}</dd>
    </div>

    <div class="text-gray-darker">
      <dt class="visually-hidden">{{ t('rateShop.cityState') }}</dt>
      <dd class="m-0">{{ location.cityState }}</dd>
    </div>
  </dl>
  <div v-else class="shipping-point-search-result">-</div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import { toRef, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShippingPoint } from '@/model';

const props = defineProps({
  shippingPoint: {
    type: Object as PropType<ShippingPoint>,
    default: () => undefined,
  },
});
const { shippingPoint } = toRefs(props);

const { t } = useI18n();

const location = toRef(() => shippingPoint?.value?.location);
</script>
